import {TreeViewBaseItem} from '@mui/x-tree-view';
import {ExtendedTreeItemProps} from '../../shared/interfaces';
export interface TreeItem {
  id: string;
  text: string;
  parent: string;
  type: string;
  a_attr: any;
  calid: any;
  isGroup?: string;
  isLocked: boolean;
  securityGroupId: number;
}

// Main class to map the data
export class AccessControlResponse {
  commentList: TreeItem[] | null;
  keyWordList: TreeItem[] | null;
  folderList: TreeItem[] | null;
  tagList: TreeItem[] | null;
  annotationList: TreeItem[] | null;
  productionsList: TreeItem[] | null;
  projectFieldsList: TreeItem[] | null;
  redactionList: TreeItem[] | null;
  assignmentList: TreeItem[] | null;

  // Selected items
  commentList_Selected: TreeItem[] | null;
  keyWordList_Selected: TreeItem[] | null;
  folderList_Selected: TreeItem[] | null;
  tagList_Selected: TreeItem[] | null;
  annotationList_Selected: TreeItem[] | null;
  productionsList_Selected: TreeItem[] | null;
  projectFieldsList_Selected: TreeItem[] | null;
  redactionList_Selected: TreeItem[] | null;
  assignmentList_Selected: TreeItem[] | null;

  // Additional properties
  isSecurityGroupLevel: boolean;
  isAnalyticInProgress: boolean;
  documentCount: number;

  constructor(data: any) {
    this.commentList = data.commentList || null;
    this.keyWordList = data.keyWordList || null;
    this.folderList = data.folderList || null;
    this.tagList = data.tagList || null;
    this.annotationList = data.annotationList || null;
    this.productionsList = data.productionsList || null;
    this.projectFieldsList = data.projectFieldsList || null;
    this.redactionList = data.redactionList || null;
    this.assignmentList = data.assignmentList || null;

    this.commentList_Selected = data.commentList_Selected || null;
    this.keyWordList_Selected = data.keyWordList_Selected || null;
    this.folderList_Selected = data.folderList_Selected || null;
    this.tagList_Selected = data.tagList_Selected || null;
    this.annotationList_Selected = data.annotationList_Selected || null;
    this.productionsList_Selected = data.productionsList_Selected || null;
    this.projectFieldsList_Selected = data.projectFieldsList_Selected || null;
    this.redactionList_Selected = data.redactionList_Selected || null;
    this.assignmentList_Selected = data.assignmentList_Selected || null;

    this.isSecurityGroupLevel = data.isSecurityGroupLevel || false;
    this.isAnalyticInProgress = data.isAnalyticInProgress || false;
    this.documentCount = data.documentCount || 0;
  }
}
export interface AccessItem {
  id: string;
  isLocked: boolean;
}

export class AccessControl {
  commentList: AccessItem[];
  keyWordList: AccessItem[];
  folderList: AccessItem[];
  tagList: AccessItem[];
  annotationList: AccessItem[];
  productionsList: AccessItem[];
  projectFieldsList: AccessItem[];
  redactionList: AccessItem[];
  assignmentList: AccessItem[];
  calModelsToDelete: number[];

  constructor(data?: Partial<AccessControl>) {
    this.commentList = data?.commentList ?? [];
    this.keyWordList = data?.keyWordList ?? [];
    this.folderList = data?.folderList ?? [];
    this.tagList = data?.tagList ?? [];
    this.annotationList = data?.annotationList ?? [];
    this.productionsList = data?.productionsList ?? [];
    this.projectFieldsList = data?.projectFieldsList ?? [];
    this.redactionList = data?.redactionList ?? [];
    this.assignmentList = data?.assignmentList ?? [];
    this.calModelsToDelete = data?.calModelsToDelete ?? [];
  }
}

export class SecurityGroupRequest {
  securityGroupID: number;
  securityGroupName: string;
  accessControl: AccessControl;
  isSecurityGroupLevel: boolean;

  constructor(data?: Partial<SecurityGroupRequest>) {
    this.securityGroupID = data?.securityGroupID ?? 0;
    this.securityGroupName = data?.securityGroupName ?? '';
    this.accessControl = new AccessControl(data?.accessControl);
    this.isSecurityGroupLevel = data?.isSecurityGroupLevel ?? false;
  }
}
export type TreeNode = TreeViewBaseItem<ExtendedTreeItemProps> & {
  parent?: string | null;
  isGroup?: string;
  isLocked?: boolean;
  text?: string;
  securityGroupId?: string | null;
};

export interface ViewSecurityGroupGridProps {
  selectedGroup: string | null;
  onRightDataChange?: (data: Record<string, TreeNode[]>) => void;
  onTreeViewSelectionFlag?: (hasSelection: boolean) => void;
  refreshKey?: number;
}
